import React, { useEffect, useState, useCallback } from "react";
import { Form, Label } from "semantic-ui-react";
import { MentionsInput, Mention } from "react-mentions";
import { decodeCron } from "../utils/decodeCron";

const options = [
  { key: "S", text: "Si", value: true },
  { key: "N", text: "No", value: false }
];

export const varsSMS = [
  {
    display: "Nombre",
    id: "#nombre#"
  },
  {
    display: "Apellido 1",
    id: "#apellido1#"
  },
  {
    display: "Apellido 2",
    id: "#apellido2#"
  },
  {
    display: "Nombre Campaña",
    id: "#nombreCampaña#"
  },
  {
    display: "Cupo",
    id: "#cupo#"
  },
  {
    display: "Plazo",
    id: "#plazo#"
  },
  {
    display: "Fecha Vencimiento",
    id: "#fechaVto#"
  }
];

export const defaultMentionStyle = {
  backgroundColor: "#cee4e5"
};

export const defaultStyle = {
  "&multiLine": {
    highlighter: {
      padding: 9
    },

    input: {
      borderRadius: 5,
      minHeight: 130,
      padding: 9
    }
  },

  "&singleLine": {
    highlighter: {
      left: 5,
      padding: 10
    },
    input: {
      width: "100%"
    }
  },

  control: {
    backgroundColor: "#fff",
    fontSize: 14,
    fontWeight: "normal"
  },

  highlighter: {
    overflow: "hidden"
  },

  input: {
    margin: 0
  },

  suggestions: {
    item: {
      "&focused": {
        backgroundColor: "#cee4e5"
      },
      borderBottom: "1px solid rgba(0,0,0,0.15)",

      padding: "5px 15px"
    },

    list: {
      backgroundColor: "white",
      border: "1px solid rgba(0,0,0,0.15)",
      fontSize: 14
    }
  }
};

export const SMSNotification = ({
  cdSmsNotification,
  modification,
  onChangeValuesObject,
  errors
}) => {
  const typeObjectName = "cdSmsNotification";

  useEffect(() => {
    const cdSmsNotificationDataSource = cdSmsNotification || {};

    if (cdSmsNotificationDataSource.template)
      setTemplate(cdSmsNotificationDataSource.template);

    if (cdSmsNotificationDataSource.sendMessage)
      setSendMessage(cdSmsNotificationDataSource.sendMessage);

    if (cdSmsNotificationDataSource.cron) {
      const [days, hours] = decodeCron(cdSmsNotificationDataSource.cron);
      setCronDays(days);
      setCronHours(hours);
    }
  }, [cdSmsNotification]);

  const [readOnly, setReadOnly] = useState(false);
  useEffect(() => {
    setReadOnly(modification === false);
  }, [modification]);

  const [template, setTemplate] = useState("");
  const [sendMessage, setSendMessage] = useState(false);
  const [cronDays, setCronDays] = useState(1);
  const [cronHours, setCronHours] = useState("23:00");

  const onChange = useCallback((_, newValue) => setTemplate(newValue), [
    setTemplate
  ]);

  const onChangeSendMessage = useCallback(
    (_, newValue) => setSendMessage(newValue.value),
    [setSendMessage]
  );

  const onChangeCronDays = useCallback(
    (_, newValue) => {
      if (/^\d+$/.test(newValue.value)) setCronDays(newValue.value);
    },
    [setCronDays]
  );

  const [errorsInput, setErrorsInput] = useState({
    cronDays: false,
    cronHours: false,
    sendMessage: false,
    template: false
  });

  const updateValues = () => {
    const cronHoursTemp = cronHours.split(":");
    let cronExpression = `0 ${cronHoursTemp[0] || 0} ${cronHoursTemp[1] ||
      0} 1/${cronDays} * ? *`;

    let cdSmsNotificationTempData = {
      cron: cronExpression,
      sendMessage,
      template
    };

    onChangeValuesObject(typeObjectName, cdSmsNotificationTempData);
  };

  useEffect(() => {
    updateValues();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [template, sendMessage]);

  const onChangeCronHours = useCallback(
    (_, newValue) => {
      if (sendMessage && !newValue.value) setErrorTimeOut(["cronHours"]);
      setCronHours(newValue.value);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [sendMessage]
  );

  const setErrorTimeOut = name => {
    const errorsInputTemp = errorsInput;
    let inputsErrorsTempTrue = {};
    let inputsErrorsTempFalse = {};

    if (typeof name === "object") {
      for (let i = 0; i < name.length; i++) {
        const element = name[i];
        inputsErrorsTempTrue[element] = true;
        inputsErrorsTempFalse[element] = false;
      }
    } else {
      inputsErrorsTempTrue[name] = true;
      inputsErrorsTempFalse[name] = false;
    }

    setErrorsInput({ ...errorsInputTemp, ...inputsErrorsTempTrue });

    setTimeout(() => {
      setErrorsInput({ ...errorsInputTemp, ...inputsErrorsTempFalse });
    }, 5000);
  };

  return (
    <Form>
      <Form.Group widths="equal">
        <Form.Select
          fluid
          error={errorsInput.sendMessage}
          label="Enviar mensaje"
          options={options}
          placeholder="Enviar mensaje"
          value={sendMessage}
          onChange={onChangeSendMessage}
          disabled={readOnly}
        />
        <Form.Input
          fluid
          label="Días"
          placeholder="Días"
          type="number"
          value={cronDays}
          onChange={onChangeCronDays}
          error={errorsInput.cronDays || errors.cronDays}
          readOnly={readOnly}
          onBlur={() => (!readOnly ? updateValues() : null)}
        />
        <Form.Input
          value={cronHours}
          onChange={onChangeCronHours}
          fluid
          label="Hora"
          placeholder="Hora"
          type="time"
          error={
            errorsInput.cronHours ||
            errors.cronHours ||
            (!cronHours && sendMessage)
          }
          readOnly={readOnly}
          onBlur={() => (!readOnly ? updateValues() : null)}
        />
      </Form.Group>
      {!readOnly ? (
        <Form.Field className={errors.template ? "error field" : ""}>
          <MentionsInput
            placeholder={"Utilize @ para agregar variables"}
            value={template}
            onChange={onChange}
            style={defaultStyle}
            className="ui fluid input"
          >
            <Mention
              trigger="@"
              data={varsSMS}
              style={defaultMentionStyle}
              data-error={errors.template}
            />
          </MentionsInput>
          {errors.template ? (
            <Label basic color="red" pointing>
              {errors.template}
            </Label>
          ) : null}
        </Form.Field>
      ) : (
        <Form.TextArea value={template} readOnly={readOnly} />
      )}
    </Form>
  );
};

SMSNotification.defaultProps = {
  errors: {}
};
